<template>
  <div class="box">
    <!-- 组件名当作标签 -->

    <global-header/>
    <!--<sidebar/>-->

    <div class="main w">
      <div class="left">
        <Left/>
      </div>

      <div class="right">
        <el-card :body-style="{'display': 'flex', 'padding':' 24px 0'}">

          <div class="wing-blank" style="width: 100%;">
            <div class="page_header" style="margin-bottom:0px !important">
              <span class="page_header_title">个人信息</span>
            </div>
            <div class="profile_pad">
              <template v-if="profile.mobile">
                <div class="profile_left" style="width:30% !important">
                  <div class="personal">
                    <div class="rank">
                      <div class="nickname">
                        <span class="label">会员名：</span>{{profile.name}}</div>
                      <div class="nickname">
                        <span class="label">会员等级：</span>{{profile.price_level.name}}
                      </div>
                      <div class="nickname">
                        <span class="label">手机号码：</span>{{profile.mobile}}
                      </div>
                      <div class="nickname">
                        <span class="label">账户余额：</span>￥{{profile.balance}}
                        <a href="/recharge_center" class="link" style="color:#0067ed">充值</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="profile_right">
                  <div class="company" v-if="customerService.mobile">
                    <!--<div class="com_profile nickname">{{ config.company_name }}</div>-->
                    <div class="c_name">
                      <span class="label">客服QQ：</span>{{config.qq}}
                    </div>
                    <div class="c_name">
                      <span class="label">客服电话：</span>{{config.tel}}
                    </div>
                    <div class="c_name">
                      <span class="label">公司名称：</span>{{config.company_name}}
                    </div>
                    <div class="c_name">
                      <span class="label">联系地址：</span>{{config.address}}
                    </div>
                  </div>
                </div>
              </template>

            </div>
          </div>

        </el-card>
        <white-space/>
        <el-card :body-style="{'display': 'flex', 'padding':' 24px 0'}">
          <div class="wing-blank" style="width: 100%;">
            <div class="page_header" style="margin-bottom:0px !important">
              <span class="page_header_title">温馨提示</span>
            </div>
            <div style="font-size:13px">
              <p>星期一至星期五 ，上午9:00~12:00 下午14:00~18:00。星期六、星期天 可在后台自助提交稿件，周一安排发布。</p><br>
              <p>
                <span style="color:#FF9900">Step1：注册账号</span> 填写账号、密码、联系方式，点击[提交]完成注册<br>
                <span style="color:#FF9900">Step2：预存款项</span> 登陆后台，点击[在线充值]，选择您的支付方式充值，充值发布文章费用<br>
                <span style="color:#FF9900">Step3：开始发稿</span> 点击[文章发布]，填写标题、内容，点击[下一步]，选择您要发布的媒体，点击[提交]完成发布<br>
                <span style="color:#FF9900">Step4：查看文章</span> 点击[文章管理]，查看文章发布状态，文章发布成功后后台会显示链接，发布时间24小时内<br>
                <span style="color:#FF9900">Step5：售后服务</span> 如果您的文章发布没有发布成功不收费，如您有任何疑问有，可以通过后台显示的QQ联系我们<br>
                <span style="color:#FF9900">Step6：软文代写</span> 如果您没有准备文章，点击[文章代写]，填写代写要求，工作时间2日内交稿，不满意可重写
              </p>
            </div>
            <white-space/>
          </div>
        </el-card>
      </div>


    </div>

    <white-space/>

    <global-footer/>
    <WechatLogin appid="wx10b9f34ef66e64bd" scope="snsapi_login" state="bind" :visible="wechatVisible" v-on:wechatHidden="wechatVisible=false"
                 redirect_uri="https://i.xinmeibao.com/wechat_req_res.html" />
  </div>
</template>

<script>
  function getQueryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
  }

  var code = getQueryString("code");

  //引进来组件
  import Head from "../global/Header.vue";
  import Foot from "../global/Footer.vue";
  import Left from "../own/Left.vue";
  import WechatLogin from '../auth/WechatLogin'

  import { ContentLoader } from 'vue-content-loader'

  export default {
    data() {
      return {
        wechatVisible: false,
        orderProfile: {},
        dialogTableVisible: false
      };
    },
    computed: {
      profile() {
        return this.$store.state.profile;
      },
      customerService(){
        return this.$store.state.customerService;
      }
    },
    //方法
    methods: {
      getQueryString(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]);
        return null;
      },
      loadCS() {
        this.$http.get("personal/customer_service").then(response => {
          if (response.success) {
            this.$store.commit('changeCustomerService',response.data);
          }
        });
      },
      loadTStat() {
        this.$http.get("personal/transaction_stat").then(response => {
          if (response.success) {
            this.orderProfile = response.data;
          }
        });
      }
    },

    //配置组件(对象的简写方式)
    components: {
      Head,
      Foot,
      Left,
      WechatLogin,
      ContentLoader
    },
    //   渲染时触发
    created() {
      this.loadTStat();

      this.loadCS();
    },
    mounted() {
      let code = this.getQueryString("code");
      if (code) {
        this.$http
          .get(
            "https://api.szuckj.net/api/connect/wechat/response?action=bind&code=" +
            code
          )
          .then(response => {
            if (response.success) {
              this.$alert("绑定成功", {
                confirmButtonText: "确定",
                type: "success"
              });
            }
          });
      }
    }
  };

</script>

<style scoped lang="scss">
  .el-dialog {
    width: 359px;
  }

  /*个人信息修改  328*/

  .add-woa-btn {
    width: 250px;
    height: 50px;
  }

  .wechat-description {
    text-align: center;
    margin-top: 24px;
    font-size: 14px;
    color: #666
  }

  .order_stat {
    font-size: 26px;
    padding-left: 12px;
    color: #fff;
    text-shadow: 0 0 2px #bdbdbd;
  }

  #login_container {
    /* position: fixed;
top: 40%;
left: 40%; */
    width: 300px;
    margin: 0 auto;
    background: #ffffff;
  }

  .profile_pad {
    margin: 0 auto;
    display: flex;
    flex-direction: row;
  }

  .profile_left,
  .profile_right {
    display: flex;
  }

  .profile_left {
    flex-direction: column;
  }

  .profile_right {
    flex-direction: row;
  }

  .h3 {
    width: 70px;
    height: 50px;
    line-height: 50px;
    font-size: 14px;
    color: #666;
  }

  .label {
    width: 80px;
    display: inline-block;
  }

  .personal {
    display: flex;
    flex-direction: row;
    align-items:center;
    justify-content: flex-start;
  }
  .avator,
  .avator img {
    width: 100px;
    height: 100px;
    border-radius: 100%;
    background-color: #ccc;
  }

  .rank {
    display: flex;
    flex-direction: column;
  }

  .nickname {
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    color: #333;
  }

  .telphone {
    height: 18px;
    line-height: 18px;
    margin: 6px 0;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    color: #999;
  }

  .icon-shouji {
    font-size: 18px;
    margin-right: 5px;
  }

  .number {
    font-size: 12px;
    /* font-weight: bold; */
  }

  .plan {
    position: relative;
  }

  .plan progress {
    margin-top: 10px;
    width: 350px;
    font-size: 14px;
    height: 20px;
    line-height: 20px;
    border: 1px solid #f9f8f8;
    background-color: #fff;
    color: #fff;
    /*IE10*/
    border-radius: 6px;
  }

  progress::-moz-progress-bar {
    background: #fe8658;
  }

  progress::-webkit-progress-bar {
    background: #fff;
  }

  progress::-webkit-progress-value {
    background: #fe8658;
  }

  .details {
    font-size: 12px;
    color: #fff;
    position: absolute;
    left: 30px;
    top: 10px;
  }

  /* 个人信息右侧 */

  .company {
    display: flex;
    flex-direction: column;
    margin-right: 48px
  }

  .wechat-qrcode {
    box-shadow: 0 0 2px #9E9E9E;
    width: 120px;
    height: 120px;
  }

  .com_profile {
    font-size: 15px;
    color: #333;
  }

  .c_name {
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    color: #666;
  }

  .view {
    font-size: 12px;
    color: #78b8e9;
  }

  .edit {
    margin-top: 30px;
    font-size: 14px;
    color: #78b8e9;
  }

  /* 账户余额 */

  .account {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: 40px;
    line-height: 40px;
    align-items: center;
  }

  .rest {
    font-size: 14px;
    color: #666;
    margin-right: 12px
  }


  /* 个人中心 */

  .per_center {
    background-color: #fff;
    height: 57px;
  }

  .per_center .per_center_left {
    font-size: 14px !important;
    color: #646464;
    line-height: 57px;
    margin-left: 35px;
  }

  .per_center_left span {
    font-size: 14px
  }

  .per_center .per_center_right ul {
    width: 345px;
    margin-right: 28px;
  }

  .per_center .per_center_right li {
    font: 15px "Microsoft Yahei";
    color: #434343;
    float: left;
    width: 25%;
    text-align: center;
    line-height: 57px;
  }

  .per_center_left a {
    color: #666666;
    font-size: 14px
  }

  .per_center .per_center_right li.now {
    font-size: 17px;
  }

  .main {
    margin-top: 24px;
    display: flex;
    justify-content: space-between
  }

  .main>.left {
  }

  .main>.right {
    width: 100%;
  }

  .main .main_top {
    height: 247px;
  }

  .main .main_top .per_profile {
    width: 662px;
    height: 100%;
    background-color: #fff;
    padding: 26px 30px 32px 30px;
    box-sizing: border-box;
  }

  .main .main_top .per_profile .per_profile_top span,
  .main .main_top .per_profile .per_profile_top>a {
    font: 14px "Microsoft YaHei";
    color: #bababa;
  }

  .main .main_top .per_profile .per_profile_center {
    margin: 10px 0;
  }

  .main .main_top .per_profile .per_profile_center>img {
    width: 100px;
    height: 80px;
    border-radius: 50%;
  }

  .main .main_top .per_profile .per_profile_center>div {
    margin-left: 25px;
  }

  .main .main_top .per_profile .per_profile_center>div h3 {
    font: 18px "Microsoft YaHei";
    color: #161616;
    margin-bottom: 10px;
  }

  .main .main_top .per_profile .per_profile_center>div>img {
    margin-right: 16px;
  }

  .main .main_top .per_profile .per_profile_center>div a {
    font: 14px "Microsoft YaHei";
    color: #86bfef;
  }

  .main .main_top .per_profile .per_profile_bottom span {
    font: 14px "Microsoft YaHei";
    color: #979797;
    margin-right: 30px;
  }

  .main .main_top .per_profile .per_profile_bottom span:nth-child(2) {
    margin-right: 30px;
  }

  .main .main_top .per_profile .per_profile_bottom span:last-of-type {
    color: #555;
    margin: 0;
  }

  .main .main_top .per_profile .per_profile_bottom .bar {
    margin-top: 16px;
    width: 440px;
    height: 31px;
    background-color: #fc835a;
    border-radius: 5px;
  }

  .main .main_top .per_profile .per_profile_bottom button {
    margin-top: 16px;
    height: 31px;
    width: 60px;
    border-radius: 15px;
    border: 0;
    color: #fff;
    font: 14px "Microsoft YaHei";
    background-color: #fc835a;
  }

  .main .main_top .com_profile {
    width: 426px;
    height: 100%;
    background-color: #fff;
    padding: 26px 30px 32px 30px;
    box-sizing: border-box;
  }

  .main .main_top .com_profile .com_profile_top {
    margin-bottom: 20px;
  }

  .main .main_top .com_profile .com_profile_top span,
  .main .main_top .com_profile .com_profile_top>a {
    font: 14px "Microsoft YaHei";
    color: #bababa;
  }

  .main .main_top .com_profile p {
    font: 16px "Microsoft YaHei";
    color: #979797;
    margin-bottom: 30px;
  }

  .main .main_top .com_profile p:first-of-type>span {
    font: 18px "Microsoft YaHei";
    color: #555;
  }

  .main .main_top .com_profile p>span {
    font: 16px "Microsoft YaHei";
    color: #7c7c7c;
  }

  .main .main_center .order-card {
    display: flex;
    justify-content: space-between;
  }

  .main .main_center .order-card .order-item {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .main .main_center div div {
    width: 254px;
    height: 92px;
    position: relative;
    background: url("../../img/orange.png") no-repeat center center;
    background-size: 100%;
    text-align: center;
    /* line-height: 92px; */
    display: table;
    box-sizing: border-box;
  }

  .main .main_center div div:last-of-type {
    margin-right: 0px;
  }

  .main .main_center div div p {
    font-size: 16px;
    color: #fff;
    vertical-align: middle;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .main .main_center .label {
    font-size: 16px
  }

  .main .main_center ul li p>span:nth-child(3) {
    /* display: inline-block;
margin-bottom: 10px; */
    font-size: 24px;
    margin-left: 10px;
  }

  .main .main_center ul li a {
    position: absolute;
    bottom: 14px;
    right: 28px;
    font-size: 14px;
    color: #fff;
  }

  .main .main_bottom {
    min-height: 600px;
    position: relative;
  }

  .main .main_bottom .begin {
    margin-top: 33px;
    margin-left: 30px;
    font-size: 14px;
    color: #333;
  }

  .main .main_bottom .begin select {
    margin-left: 16px;
    width: 100px;
    height: 30px;
  }

  .main .main_bottom .end {
    margin-top: 33px;
    margin-left: 30px;
    font-size: 14px;
    color: #333;
  }

  .main .main_bottom .end select {
    margin-left: 16px;
    width: 100px;
    height: 30px;
  }

  .main .main_center div div:first-child {
    background: url("../../img/orange.png") no-repeat center center;
    background-size: 100% 100%;
  }

  .main .main_center div div:nth-child(2) {
    background: url("../../img/blue.png") no-repeat center center;
    background-size: 100% 100%;
  }

  .main .main_center div div:nth-child(3) {
    background: url("../../img/green.png") no-repeat center center;
    background-size: 100% 100%;
  }

  .main .main_center div div:nth-child(4) {
    background: url("../../img/gray.png") no-repeat center center;
    background-size: 100% 100%;
  }

  .profile_box .profile_companyprofile_title {
    border-bottom: 1px solid #eaeaea;
  }

  .orangeline {
    width: 6px;
    height: 18px;
    background: #f08c19;
    margin-bottom: 6px;
    display: inline-block;
    vertical-align: middle;
  }

  .title {
    color: #333333;
    font-size: 16px;
    font-weight: 800;
    display: inline-block;
    margin-left: 9px;
  }

  .addwoabtn {
    width: 218px;
    height: 60px;
    line-height: 60px;
    color: #f08c19;
    border: 1px solid #f08c19;
    text-align: center;
    margin-top: 65px;
    margin-right: auto;
    margin-left: auto;
    border-radius: 5px;
  }

  .addwoabtn>img {
    width: 20px;
    height: 20px;
    margin-top: -2px;
    vertical-align: middle;
  }

  .home_title {
    border-bottom: 1px solid #eaeaea;
  }

  .showlist {
    width: 865px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
  }

  .showlist>li img {
    width: 87px;
    height: 87px;
    border-radius: 50%;
    box-shadow: 0 0 20px #F5F5F5;
  }

  .showlist li:hover>p {
    color: #0067ed !important;
    cursor: pointer;
  }

  .showlist li:hover {
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/components/home/Index.vue